export default __webpack_public_path__ + "static/media/img-egt-swp.34cd44d1.png";